import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from './../../../BaseFramework/shared/models/error.model';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler,
  VehicleService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.scss']
})
export class VehicleDetailsComponent implements OnInit {
  _currentComponentName = "MotorInsuredDetailsComponent"

  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private vehicleService: VehicleService) { }

  //Declaraions which might need developer input
  motorInsuredDetailsForm: FormGroup
  MOTORINSUREDDETAILSFORMNAME = "motorInsuredDetailsForm"
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd', 'clmMannerOfLossCd','vehicleMakeCd','vehicleBodyTypeCd','mapRegionCd',
  'ageCategoryCd', 'vehicleRatingTypeCd','vehicleAccessoryCd','fuelTypeCd']
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: string;

  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  clmEventTypeCd
  item

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let validationResult = this.validateOutput(this.motorInsuredDetailsForm)
      if (!validationResult.isInvalid)
        this.EmitComponentOutput(this.motorInsuredDetailsForm)
      else {
        this.EmitComponentOutput(validationResult)
      }
    })
  }


  validateOutput(o): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())
    if (!this.isdateValid) {
      let errorDO = new ErrorDO()
      errorDO.errorMsg = "Event date and Retype Event Date mismatch";
      errorDO.componentName = this.getCurrentComponentName();
      errorDO.fieldName = "Event Date"
    }

    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  // Front end error list
  errorList: any = [];

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    if (this._inputDataForEdit != null) this.initializeClientSearchForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
  }



  /**
   * Form Trasactions
   */

  FormFieldNameMap = {
    make: "Make",
    model: "Model",
    variant: "Variant",
    bodyType: "Body Type",
    regionCd: "Region",
    categoryCd: "Category",
    ratingType: "Rating Type",
    fuelTypeCd: "Fuel Type",
    seatingCapacity: "Seating Capacity",
    color: "color",
    engineNum: "engineNum",
    chasisNum: "chasisNum",
    plateNumber: "plateNumber",
    eventDate: "Event Date",
    retypeEventDate: "Retype Event Date",
    eventTime: "Event Time",
    retypeEventTime: "Retype Time",
    causeOfDeath: "Cause of Death",
    intimationDt: "Intimation Date",
    receivedDt: "Received Date",
    appliedForSeatingCapacity: "No of Covered Passengers"
  }

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.motorInsuredDetailsForm = this.fb.group({
      color: this.validationUtilService.setValidationsForFormControl('color', this.MOTORINSUREDDETAILSFORMNAME, payload['color']),
      engineNum: this.validationUtilService.setValidationsForFormControl('engineNum', this.MOTORINSUREDDETAILSFORMNAME, payload['engineNum']),
      chasisNum: this.validationUtilService.setValidationsForFormControl('chasisNum', this.MOTORINSUREDDETAILSFORMNAME, payload['chasisNum']),
      plateNumber: this.validationUtilService.setValidationsForFormControl('plateNumber', this.MOTORINSUREDDETAILSFORMNAME, payload['plateNumber']),
      eventDate: this.validationUtilService.setValidationsForFormControl('eventDate', this.MOTORINSUREDDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['eventDate'])),
      retypeEventDate: this.validationUtilService.setValidationsForFormControl('retypeEventDate', this.MOTORINSUREDDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['eventDate'])),
      eventTime: this.validationUtilService.setValidationsForFormControl('eventTime', this.MOTORINSUREDDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDOsetTime(payload['eventTime'])),
      retypeEventTime: this.validationUtilService.setValidationsForFormControl('retypeEventTime', this.MOTORINSUREDDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDOsetTime(payload['eventTime'])),
      causeOfDeath: this.validationUtilService.setValidationsForFormControl('causeOfDeath', this.MOTORINSUREDDETAILSFORMNAME, payload['causeOfDeath']),
      intimationDt: this.validationUtilService.setValidationsForFormControl('intimationDt', this.MOTORINSUREDDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['intimationDt'])),
      receivedDt: this.validationUtilService.setValidationsForFormControl('receivedDt', this.MOTORINSUREDDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['receivedDt'])),
      make: this.validationUtilService.setValidationsForFormControl('make', this.MOTORINSUREDDETAILSFORMNAME, payload['make']),
      model: this.validationUtilService.setValidationsForFormControl('model', this.MOTORINSUREDDETAILSFORMNAME, payload['model']),
      variant: this.validationUtilService.setValidationsForFormControl('variant', this.MOTORINSUREDDETAILSFORMNAME, payload['variant']),
      bodyType: this.validationUtilService.setValidationsForFormControl('bodyType', this.MOTORINSUREDDETAILSFORMNAME, payload['bodyType']),
      regionCd: this.validationUtilService.setValidationsForFormControl('regionCd', this.MOTORINSUREDDETAILSFORMNAME),
      fuelTypeCd: this.validationUtilService.setValidationsForFormControl('fuelTypeCd', this.MOTORINSUREDDETAILSFORMNAME, payload['fuelTypeCd']),
      categoryCd: this.validationUtilService.setValidationsForFormControl('categoryCd', this.MOTORINSUREDDETAILSFORMNAME),
      ratingType: this.validationUtilService.setValidationsForFormControl('ratingType', this.MOTORINSUREDDETAILSFORMNAME),
      seatingCapacity: this.validationUtilService.setValidationsForFormControl('seatingCapacity', this.motorInsuredDetailsForm, payload['appliedForSeatingCapacity']),
      appliedForSeatingCapacity: this.validationUtilService.setValidationsForFormControl('appliedForSeatingCapacity',this.motorInsuredDetailsForm, payload['appliedForSeatingCapacity']),
      entryAge: this.validationUtilService.setValidationsForFormControl('entryAge', this.motorInsuredDetailsForm),
      manufacturingDt:this.validationUtilService.setValidationsForFormControl('manufacturingDt',this.motorInsuredDetailsForm, payload['manufacturingDt'])
    });
    this.getVehicleModel(payload['make']);
    this.getVehicleVariant(payload['model']);
    this.getSeatingCapacity(payload['variant']);
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.MOTORINSUREDDETAILSFORMNAME)
    return returnObj
  }

  isdateValid: any = true;
  onChange(event, type) {
    let dateCheckOutput = null

    // eventDate.isSame( moment(retypeEventDate));

    if (type == "EVENT") {
      var eventDate = moment(event, "DD-MM-YYYY");
      var retypeEventDate = moment(this.motorInsuredDetailsForm.get('retypeEventDate').value, "DD-MM-YYYY");

      this.showOutside = false;
      this.d1Visible = false;
      if (retypeEventDate == null || eventDate == null)
        dateCheckOutput = false;

      if (eventDate.format('DD-MM-YYYY') == retypeEventDate.format('DD-MM-YYYY'))
        dateCheckOutput = true;
      else
        dateCheckOutput = false;

    } else {

      this.d2Visible = false;
      var retypeEventDate = moment(event, "DD-MM-YYYY");
      var eventDate = moment(this.motorInsuredDetailsForm.get('eventDate').value, "DD-MM-YYYY");


      if (retypeEventDate == null || eventDate == null)
        dateCheckOutput = false;

      if (eventDate.format('DD-MM-YYYY') == retypeEventDate.format('DD-MM-YYYY'))
        dateCheckOutput = true;
      else
        dateCheckOutput = false;
    }

    this.isdateValid = dateCheckOutput
    
  }


  outisideClick(event) {
    if (this.showOutside == true)
      this.d1Visible = true;
    else
      this.d1Visible = false;
    this.showOutside = false;
  }

  t1Visible: boolean = false;
  t2Visible: boolean = false;
  timeCheck: any = true
  onTimeChange(event, type) {

    let timeCheckOutput = null
    if (type == "EVENT") {

      //this.t1Visible=false;
      var retypeTime = moment(this.motorInsuredDetailsForm.get('retypeEventTime').value, "HH:mm");
      var eventTime = moment(event, "HH:mm");

      if (retypeTime == null || eventTime == null)
        timeCheckOutput = false;

      if ((eventTime.format('HH:mm') == retypeTime.format('HH:mm')))
        timeCheckOutput = true;
      else
        timeCheckOutput = false;
    } else {

      var eventTime = moment(this.motorInsuredDetailsForm.get('eventTime').value, "HH:mm");
      var retypeTime = moment(event, "HH:mm");

      if (eventTime == null || retypeTime == null)
        timeCheckOutput = false;

      if ((eventTime.format('HH:mm') == retypeTime.format('HH:mm'))) {
        timeCheckOutput = true;
        this.t2Visible = false;
      }
      else
        timeCheckOutput = false;
    }
    this.timeCheck = timeCheckOutput;
  }

  // o.controls.eventTime == null || o.controls.retypeEventTime == null)

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (!Form.valid) {
      for (const i in Form.controls) {

        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.motorInsuredDetailsForm.get(controlName), this.MOTORINSUREDDETAILSFORMNAME)
        if (Form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError.errorMessage;
            errorDO.validationLevel = validationError.validationLevel
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    return invalidFields;
  }

  // Date mask DJ's code

  d1Visible: boolean = false;
  d2Visible: boolean = false;
  showOutside: boolean = false;
  showDate(dt: string) {
    if ('d1' == dt) {
      this.showOutside = true;
      this.d1Visible = true;
    }
    else this.d2Visible = true;
  }

  hideDate(dt, val) {
    console.log("Open/Close Date", val)
    if ('d1' == dt) {
      this.showOutside = val;
      this.d1Visible = val;
    }
    else this.d2Visible = val;
  }


  showTime(tm: string) {
    if ('t1' == tm) this.t1Visible = true;
    else this.t2Visible = true;
  }
  vehicleModelList = []
  vehicleVariantList = []
  getVehicleModel(vehicleMake) {
    if (vehicleMake) {
      this.vehicleService.getvehicleModel(vehicleMake)
        .subscribe(resp => {
          this.vehicleModelList = this.commonUtilty.isArrayIterable(resp) ? resp : [];
          console.log("Model");
          // console.log(JSON.stringify(this.vehicleModelList));
        })
      // this.vehicleVariantList = null;
      // this.motorInsuredDetailsForm.controls['model'].setValue(null)
      // this.motorInsuredDetailsForm.controls['variant'].setValue(null)
      }
  }

  getVehicleVariant(vehicleModel) {
    if (vehicleModel) {
      this.vehicleService.getvehicleVariant(vehicleModel)
        .subscribe(resp => {
          // this.quotationObj.seatingCapacity = null;
          this.vehicleVariantList = resp;
          console.log("Variant");
          console.log(JSON.stringify(this.vehicleVariantList));
          
        })
    
    // this.motorInsuredDetailsForm.controls['variant'].setValue(null)
    }
  }

  getSeatingCapacity(variantCd) {
    let modelCd = this.motorInsuredDetailsForm.get('model').value;
    if (modelCd  && variantCd ) {
      this.vehicleService.getvehicleSeatingCapacity(modelCd, variantCd)
        .subscribe(resp => {
          this.motorInsuredDetailsForm.controls['seatingCapacity'].setValue(eval(resp.seatingCapacity))
          this.motorInsuredDetailsForm.controls['appliedForSeatingCapacity'].setValue(Number(resp.seatingCapacity) -1)
         
        })
     }
  }

}
